import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5085a1d2&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5085a1d2')) {
      api.createRecord('5085a1d2', component.options)
    } else {
      api.reload('5085a1d2', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5085a1d2&", function () {
      api.rerender('5085a1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bRE5Hmmg3mpb/JS/comp/openstreetmap.vue"
export default component.exports